<template>
  <v-menu v-model="menu" bottom offset-y left :close-on-content-click="false">
    <template v-slot:activator="{ on, attrs }">
      <v-btn class="float-right" small v-on="on" v-bind="attrs"
        ><v-icon left>mdi-filter-outline</v-icon>Filtrar</v-btn
      >
    </template>
    <v-card min-width="250">
      <v-card-title class="body-1 font-weight-bold"
        >Filtrar visitas</v-card-title
      >
      <v-card-text>
        <v-text-field label="Data inicial" type="date" v-model="filtros.dtini"></v-text-field>
        <v-text-field label="Data final" type="date" v-model="filtros.dtfim"></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn rounded text color="success" @click="filtrarVisitas()" class="font-weight-bold"
          >Confirmar</v-btn
        >
        <v-btn rounded text @click="menu = false">Cancelar</v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  computed: mapState("visitaTecnica", ["filtros", "configuracoes"]),
  methods: {
    ...mapActions("visitaTecnica", ["buscarVisitas"]),
    filtrarVisitas(){  
      this.buscarVisitas()
      this.menu = false
    }
  },
  data: () => ({
    menu: false,
  }),
  mounted() {
    if (this.filtros.dtini == "" && this.configuracoes.dados) {
      this.filtros.dtini = this.configuracoes.dados.filtro_dtini;
      this.filtros.dtfim = this.configuracoes.dados.filtro_dtfim;
    }
  },
};
</script>

<style>
</style>